import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { IconComponentProps } from '../IconTypes';
import { IconWrapper } from '../IconWrapper';

import { faEllipsis } from '@fortawesome/pro-light-svg-icons';

export type ProLightEllipsisProps = IconComponentProps;

export const ProLightEllipsis = ({
  className,
  onClick,
  iconProps,
  type = 'button',
  ...props
}: ProLightEllipsisProps) => {
  if (onClick) {
    return (
      <IconWrapper
        {...props}
        className={['font-awesome-button', className].join(' ')}
        type={type}
        onClick={onClick}
      >
        <FontAwesomeIcon
          {...iconProps}
          className="font-awesome-icon"
          icon={faEllipsis}
        />
      </IconWrapper>
    );
  }
  return (
    <FontAwesomeIcon
      {...iconProps}
      className={['font-awesome-icon', className].join(' ')}
      icon={faEllipsis}
    />
  );
};

ProLightEllipsis.displayName = 'ProLightEllipsis';
